const ACADEMY_API_BASE = (
  process.env.REACT_APP_ACADEMY_BACKEND_URL ||
  'https://greatleadersacademybackennd.onrender.com'
).replace(/\/$/, '');

export function academyApiUrl(path) {
  return `${ACADEMY_API_BASE}${path}`;
}

export function isAcademySitePath(pathname) {
  const path = String(pathname || '').replace(/\/+$/, '') || '/';
  return path === '/academy' || path.startsWith('/academy/');
}
